document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".content-anim").forEach((section) => {
        const hero = section.querySelector(".hero-global");
        const fadeContent = section.querySelector(".lblp-fade-content");
        const scope = section.closest(".pin-scope-fade");
        if (!hero || !fadeContent) return;

        gsap.set(fadeContent, { y: 20 });
        gsap.set(hero, { autoAlpha: 1, filter: "blur(0px)", clearProps: "visibility" });

        const tl = gsap.timeline({
            defaults: { ease: "none" },
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "bottom bottom",
                pin: hero,
                pinReparent: true,
                pinnedContainer: scope,
                pinSpacing: false,
                scrub: 0.5,
                anticipatePin: 1,
                invalidateOnRefresh: true
            }
        });

        tl.to(hero, { autoAlpha: 0, filter: "blur(10px)" })
            .to(fadeContent, { y: 0 });
    });

    ScrollTrigger.refresh();

});